import ClearIcon from '@mui/icons-material/Clear';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TablePagination,
  TextField,
  Typography,
} from '@mui/material';
import { useContext, useEffect, useState, useRef } from 'react';
import axios, { AxiosResponse } from 'axios';
import { API_ENDPOINT } from '../../../../configurations/global.config';
import ChecklistIcon from '@mui/icons-material/Checklist';
import { AuthContext } from '../../../../contexts/user-context/user-context';
import AddressInputWithAutocomplete from '../../../common/adress-input-with-autocomplete/address-input-with-autocomplete';
import { ErrorsFlattenner } from '../../../common/errors-flattenner/errors-flattenner';
import React from 'react';
import { IDeliveryBatch } from '../../../../interfaces/delivery-company/tasks';
import { emptyPickupTask } from '../../../../data/pickuptasks';
import { DeliveryState, Workflow } from '../../../../enums/orders';
import AutocompleteWithThrottle from '../../../common/autocomplete-with-throttle/autocomplete-with-throttle';
import { emptyCustomer } from '../../../../data/customers';
import { CustomerType } from '../../../../interfaces/common/customer';
import GenericTable from '../../../common/generic-table/generic-table';
import { OrderType } from '../../../../interfaces/delivery-company/orders';
import { useImmer } from 'use-immer';
import { PaginationContext } from '../../../../contexts/pagination-context';
import { buildQueryParams } from '../../../common/filter-bar/filter-bar.utils';
import { showDeliveryState } from '../../../common/styles/order-states.style';
import { MerchantType } from '../../../../interfaces/delivery-company/merchants';
import { displayLocation } from '../../../../utils/locations';
import { ILocation } from '../../../../interfaces/common/location';
import { BranchType } from '../../../../interfaces/delivery-company/branches';
import { emptyDeliveryBatch } from '../../../../data/deliverytasks';
import Grid2 from '@mui/material/Unstable_Grid2';
import { DriverType } from '../../../../interfaces/delivery-company/drivers';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';
import MultiPackageScanner, {
  validationResult,
  MultiPackageScannerHandle,
} from '../../../common/multi-package-scanner/multi-package-scanner';
import { GenericTableProps } from '../../../common/generic-table/utils';
import {
  DecodingWithOrderVal,
  generateUID,
  transformOrdersToDecodingWithOrderVal,
} from '../../../../utils/encoding';
import { getMissingPackages } from '../../../../utils/missing-packages';
import MoneyInput from '../../../common/money-input/money-input';
import { displayMoney, Money } from '../../../../utils/money';
import UpdateDriverCommission from '../update-driver-commission';
import { useSnackBar } from '../../../../contexts/snackbar';
import IncompleteAddressError from '../../../common/incomplete-address-error/incomplete-address-error';
import { showWorkflow } from '../../../common/styles/workflow-display';
import { get_cod } from '../../../../utils/cod';
import { DataResources, ResourceActionType, user_has_data_model_access, user_is_admin } from '../../../../utils/permissions';
import RerouteOrderDialog from '../../../common/reroute-order-dialog';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import { RerouteConfirmationDialog } from '../../../common/reroute-confirmation-dialog/reroute-confirmation-dialog';

interface DeliveryBatchFormProps {
  onSuccess: (b: IDeliveryBatch) => void;
  taskID?: string;
}
function DeliveryBatchForm({ taskID, onSuccess }: DeliveryBatchFormProps) {
  const [taskData, setTaskData] = useState<IDeliveryBatch>(emptyDeliveryBatch);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loadingMessage, setLoadingMessage] = useState<string>('');
  const [message, setMessage] = useState<string>('');
  const [response, setResponse] = useState<AxiosResponse>();
  const [scannedOrders, setScannedOrders] = useState<DecodingWithOrderVal[]>(
    []
  );
  const [overridingCommissionFor, setOverridingCommissionFor] = useState<
    OrderType[] | null
  >(null);
  const [commissionOverrides, setCommissionOverrides] = useState<
    Map<string, Money[]>
  >(new Map());
  const { showMessage } = useSnackBar();

  const [selectedOrders, updateSelectedOrders] = useImmer<
    Map<string, OrderType>
  >(new Map());
  
  // Orders that need rerouting (have next_leg set)
  const [ordersNeedingReroute, setOrdersNeedingReroute] = useState<OrderType[]>([]);
  const [rerouteDialogOpen, setRerouteDialogOpen] = useState(false);

  // For single order reroute confirmation when scanning
  const [pendingRerouteDecoding, setPendingRerouteDecoding] = useState<DecodingWithOrderVal | null>(null);
  const [rerouteConfirmDialogOpen, setRerouteConfirmDialogOpen] = useState(false);
  
  // Ref to access the scanner's addOrder method
  const scannerRef = useRef<MultiPackageScannerHandle>(null);

  const { user, config } = useContext(AuthContext);

  useEffect(() => {
    const getAndSetTaskData = async () => {
      if (taskID) {
        setIsLoading(true);
        const endpoint = `${API_ENDPOINT}/api/v1/delivery-batch/${taskID}/`;
        try {
          console.log(endpoint);
          const response = await axios.get<IDeliveryBatch>(endpoint, config);
          console.log('response here = ', response);
          setTaskData(response.data);
          const overrides = new Map<string, Money[]>();
          response.data.orders.forEach((order) =>
            overrides.set(order.id, order.driver_commission)
          );

          console.log("overrides = ", overrides)
          setCommissionOverrides(overrides);
        } catch (error) {
          console.log(error);
          if (axios.isAxiosError(error)) {
            setResponse(error.response);
            setMessage(
              'Failed to get task details: ' + error.response?.statusText
            );
          } else {
            setMessage('Failed to get task details');
          }
        }
        setIsLoading(false);
      }
    };

    getAndSetTaskData();
  }, []);

  const hasIncompleteAddress = scannedOrders.find(item => !item.order.customer_location?.area || !item.order.merchant_location?.area)
  
  


  const handleSubmit = async (
    decodings: DecodingWithOrderVal[],
    setIsLoading: (isLoading: boolean) => void,
    setResponse: (resp?: AxiosResponse) => void,
    setMessage: (m: string) => void,
    config: any
  ) => {
    const missingPackages = getMissingPackages(decodings);
    if (missingPackages.length > 0) {
      setIsLoading(false);
      setMessage(
        `The following packages are missing: ${missingPackages.map((item) => `package ${item[1]} from ${item[0]}`).join(', ')}`
      );
      return;
    }

    setIsLoading(true);
    setResponse(undefined);
    setLoadingMessage('Saving delivery batch...');

    const requestData = {
      ...taskData,
      orders: Array.from(decodings.values()).map((item) => {
        return { order_id: item.order.order_id };
      }),
      driver_commissions: Array.from(decodings.values()).map((item) =>
        commissionOverrides.has(item.order.id)
          ? commissionOverrides.get(item.order.id)
          : (item.order.workflow == Workflow.STANDARD ? taskData.driver!.default_commission : taskData.driver!.default_return_commission)
      ),
    };

    try {
      if (taskID) {
        // modifying existing batch
        const response = await axios.put<IDeliveryBatch>(
          `${API_ENDPOINT}/api/v1/delivery-batch/${taskID}/`,
          requestData,
          config
        );
        setResponse(response);
        onSuccess(response.data);
      } else {
        // creating new batch
        const response = await axios.post<IDeliveryBatch>(
          `${API_ENDPOINT}/api/v1/delivery-batches/`,
          requestData,
          config
        );
        setResponse(response);
        onSuccess(response.data);
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        setMessage('Failed to save delivery batch: ' + e.response?.statusText);
      } else {
        setMessage('Failed to save delivery batch');
      }
      console.log(e);
    }
    setIsLoading(false);
    setLoadingMessage('');
  };

  const handleFetchDrivers = async (query: string): Promise<DriverType[]> => {
    const endpoint = `${API_ENDPOINT}/api/v1/drivers/?page_size=10&name_or_phone=${encodeURIComponent(query)}`;

    try {
      const response = await axios.get<{
        count: number;
        results: DriverType[];
      }>(endpoint, config);

      return response.data.results.filter((driver) => !driver.is_deleted);
    } catch (e) {
      if (axios.isAxiosError(e)) {
        setResponse(e.response);
        setMessage('Failed to fetch driver: ' + e.response?.statusText);
      } else {
        setMessage('Failed to fetch driver');
      }
    }

    return [];
  };

  const getDefaultCommission = (workflow: Workflow) => {
    if (!taskData.driver) return []
    
    return workflow === Workflow.STANDARD ?  taskData.driver!.default_commission : taskData.driver!.default_return_commission
  }

  const getDistrictSet = (orders: OrderType[]) => {
    return Array.from(
      new Set(
        orders.map((item) => {
          if (item.workflow === Workflow.STANDARD)
            return item.customer_location?.area?.district ?? '';
        })
      )
    );
  };

  const selectAllRows = (items: DecodingWithOrderVal[]) => {
    if (updateSelectedOrders)
      updateSelectedOrders((draft) => {
        items.forEach((item) => draft.set(item.id, item.order));
      });
  };

  const unSelectAllRows = (items: DecodingWithOrderVal[]) => {
    if (updateSelectedOrders)
      updateSelectedOrders((draft) => {
        items.forEach((item) => draft.delete(item.id));
      });
  };

  // Handle successful reroute - add the order to the batch
  const handleRerouteSuccess = (updatedOrder: OrderType) => {
    if (pendingRerouteDecoding && scannerRef.current) {
      // Add the rerouted order to the scanner
      const updatedDecoding: DecodingWithOrderVal = {
        ...pendingRerouteDecoding,
        order: updatedOrder,
      };
      scannerRef.current.addOrder(updatedDecoding);
    }
    setRerouteConfirmDialogOpen(false);
    setPendingRerouteDecoding(null);
  };


  return (
    <>
      <Typography
        variant="h3"
        component="h3"
        sx={{ textAlign: 'center', mt: 0, mb: 0 }}
      >
       {taskID ? 'Edit Delivery Batch' :  'New Delivery Batch'}
      </Typography>
      <div style={{ textAlign: 'center', margin: 'auto' }}>
        Regions:{' '}
        {getDistrictSet(scannedOrders.map((item) => item.order)).join(',')}
      </div>
      {hasIncompleteAddress && <IncompleteAddressError />}
      <br /> <br />
      {isLoading ? (
        <>
          {loadingMessage}
          <br />
          <LinearProgress />
        </>
      ) : (
        <>
          {message !== '' && (
            <Alert
              severity={
                response && response.status >= 200 && response.status < 300
                  ? 'success'
                  : 'error'
              }
            >
              <>
                {message}

                {response && response.status >= 300 && (
                  <ErrorsFlattenner rawErrors={response.data} />
                )}
              </>
            </Alert>
          )}

          {taskData && (
            <>
              <div
                style={{
                  width: '100%',
                  textAlign: 'center',
                  margin: 'auto',
                }}
              >
                <FormControl fullWidth sx={{ textAlign: 'center' }}>
                  <AutocompleteWithThrottle
                    label={'Choose Driver'}
                    required={true}
                    fetch={handleFetchDrivers}
                    value={taskData.driver}
                    fetchAllOnLoad
                    getOptionLabel={(option: DriverType) => user_is_admin(user) ?  `${option.name} ${option.phone_number} (${displayMoney(option.default_commission)} / order)` : `${option.name} ${option.phone_number}`}
                    onChange={(e, value) => {
                      setTaskData({
                        ...taskData,
                        driver: value,
                      });
                      setCommissionOverrides(new Map)
                    }}
                  />
                </FormControl>

                <br />
                <br />

                

                <MultiPackageScanner
                  ref={scannerRef}
                  label="package id"
                  enforceAckOfFailedScans={true}
                  onScanResultChanged={(o) => setScannedOrders(o)}
                  allowUndoScan={true}
                  defaultScannedOrders={transformOrdersToDecodingWithOrderVal(
                    taskData.orders
                  )}
                  scannedOrdersTableHeader={
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        margin: 10,
                        flexWrap: 'wrap',
                        gap: 8,
                      }}
                    >
                      <Chip
                        icon={<ChecklistIcon />}
                        color="primary"
                        label={`Selected ${selectedOrders.size}/${scannedOrders.length}`}
                        variant={
                          selectedOrders.size == scannedOrders.length &&
                          selectedOrders.size > 0
                            ? 'filled'
                            : 'outlined'
                        }
                      />

                      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                        {/* Reroute button for orders that need transfer */}
                        <Button
                          variant="outlined"
                          size="small"
                          color="warning"
                          startIcon={<AltRouteIcon />}
                          disabled={
                            selectedOrders.size === 0 ||
                            !Array.from(selectedOrders.values()).some(o => o.next_leg)
                          }
                          onClick={() => {
                            const ordersWithNextLeg = Array.from(selectedOrders.values())
                              .filter(o => o.next_leg);
                            if (ordersWithNextLeg.length > 0) {
                              setOrdersNeedingReroute(ordersWithNextLeg);
                              setRerouteDialogOpen(true);
                            }
                          }}
                        >
                          Reroute ({Array.from(selectedOrders.values()).filter(o => o.next_leg).length})
                        </Button>
                        
                        <Button
                          variant="contained"
                          size="small"
                          disabled={selectedOrders.size == 0}
                          onClick={() =>
                            setOverridingCommissionFor(
                              Array.from(selectedOrders.values())
                            )
                          }
                        >
                          Change Driver Commission
                        </Button>
                      </Box>
                    </div>
                  }
                  validator={(
                    decoding: DecodingWithOrderVal
                  ): validationResult => {
                    if (taskData.driver == null) {
                      return {
                        validated: false,
                        error: 'Please choose driver first',
                      }
                    }
                    if (
                      decoding.order.delivery_state !=
                      DeliveryState.AT_WAREHOUSE
                    )
                      return {
                        validated: false,
                        error: 'order is not at warehouse.',
                      };

                    if (decoding.order.customer_location?.area == undefined) {
                      return {
                        validated: false,
                        error: 'customer location is incomplete.'
                      }
                    }

                    if (decoding.order.merchant_location?.area == undefined) {
                      return {
                        validated: false,
                        error: 'merchant location is incomplete.'
                      }
                    }

                    // Check if order needs transfer to another branch - show confirmation dialog
                    if (decoding.order.next_leg) {
                      setPendingRerouteDecoding(decoding);
                      setRerouteConfirmDialogOpen(true);
                      return {
                        validated: false,
                        pendingConfirmation: true,
                      };
                    }

                    return { validated: true };
                  }}
                  actionType={taskID ? 'Save Task' : 'Create Task'}
                  disabled={taskID != undefined && !user_has_data_model_access(user, DataResources.DELIVERY_BATCH, ResourceActionType.UPDATE)}
                  getRenderOrdersProps={(
                    decodings: DecodingWithOrderVal[]
                  ): GenericTableProps<DecodingWithOrderVal> => {
                    return {
                      sourceView: "create-delivery-batch-form",
                      items: decodings,
                      fullWidth: true,
                      columns: [
                        {
                          id: 'checkbox',
                          header: (
                            <div>
                              <Checkbox
                                color="primary"
                                indeterminate={
                                  selectedOrders.size > 0 &&
                                  selectedOrders.size < scannedOrders.length
                                }
                                checked={
                                  (selectedOrders.size < scannedOrders.length ||
                                    (scannedOrders.length > 0 &&
                                      selectedOrders.size ===
                                        scannedOrders.length)) &&
                                  selectedOrders.size > 0
                                }
                                onChange={(e) => {
                                  if (
                                    selectedOrders.size == scannedOrders.length
                                  )
                                    unSelectAllRows(scannedOrders);
                                  else selectAllRows(scannedOrders);
                                }}
                              />
                            </div>
                          ),
                          display_body: (decoding) => (
                            <div>
                              <Checkbox
                                color="primary"
                                checked={selectedOrders.has(decoding.id)}
                                onChange={(e) => {
                                  updateSelectedOrders((m) => {
                                    m.has(decoding.id)
                                      ? m.delete(decoding.id)
                                      : m.set(decoding.id, decoding.order);
                                  });
                                }}
                              />
                            </div>
                          ),
                        },
                        {
                          id: 'order_id',
                          header: 'Order ID',
                          display_body: (decoding) => decoding.order.order_id,
                        },
                        {
                          id: 'customer',
                          header: 'Customer',
                          display_body: (decoding) => (
                            <>
                              {decoding.order.customer?.name}
                              <br />
                              {displayLocation(
                                decoding.order.customer_location
                              )}{' '}
                            </>
                          ),
                        },
                        {
                          id: 'merchant',
                          header: 'Merchant',
                          display_body: (decoding) => (
                            <>
                              {decoding.order.merchant?.name}
                              <br />
                              {decoding.order.merchant?.address}{' '}
                            </>
                          ),
                        },
                        {
                          id: 'delivery_status',
                          header: 'Status',
                          display_body: (decoding) =>
                            showDeliveryState(decoding.order.delivery_state),
                        },
                        {
                          id: 'workflow',
                          header: 'Workflow',
                          display_body: (decoding) => showWorkflow(
                            decoding.order.workflow, 
                            decoding.order.is_exchange,
                            decoding.order.exchange_for,
                            decoding.order.return_reason
                          )
                        },
                        {
                          id: 'cod',
                          header: 'COD',
                          display_body: (decoding) => displayMoney(get_cod(decoding.order))
                        },
                        {
                          id: 'Driver Commission',
                          header: 'Driver Commission',
                          hidden: !user_is_admin(user),
                          display_body: (decoding) => {
                            return (
                              <Box sx={{ display: 'inline-block' }}>
                                <Box
                                  onClick={() =>
                                    setOverridingCommissionFor([decoding.order])
                                  }
                                  sx={{
                                    display: 'inline-block',
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: 1,
                                    bgcolor: 'grey.100',
                                    color: 'text.primary',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s',
                                    '&:hover': {
                                      bgcolor: 'grey.200',
                                    },
                                  }}
                                >
                                  {displayMoney(
                                    commissionOverrides.has(decoding.order.id)
                                      ? commissionOverrides.get(
                                          decoding.order.id
                                        )!
                                      : getDefaultCommission(decoding.order.workflow)
                                  )}{' '}
                                  {commissionOverrides.has(decoding.order.id) &&
                                    displayMoney(
                                      commissionOverrides.get(
                                        decoding.order.id
                                      )!
                                    ) !=
                                      displayMoney(
                                       getDefaultCommission(decoding.order.workflow)
                                      ) && <b>(Modified)</b>}
                                </Box>
                              </Box>
                            );
                          },
                        },
                      ],
                      getItemUID: (decoding) => generateUID(decoding),
                      selectedItems: new Map(),
                      isLoading: false,
                    };
                  }}
                  callback={handleSubmit}
                />
              </div>

              {overridingCommissionFor && taskData.driver && (
                <UpdateDriverCommission
                  orders={overridingCommissionFor}
                  driver={taskData.driver}
                  onSubmit={(m) => {
                    const newOverrides = new Map(commissionOverrides);
                    overridingCommissionFor.forEach((item) =>
                      newOverrides.set(item.id, m)
                    );
                    setCommissionOverrides(newOverrides);
                    showMessage('Commission Updated!');
                  }}
                  onClose={() => setOverridingCommissionFor(null)}
                  defaultCommission={taskData.driver.default_commission}
                />
              )}

              {/* Reroute Dialog */}
              <RerouteOrderDialog
                orders={ordersNeedingReroute}
                open={rerouteDialogOpen}
                onClose={() => {
                  setRerouteDialogOpen(false);
                  setOrdersNeedingReroute([]);
                }}
                onSuccess={() => {
                  // After successful reroute, the orders no longer have next_leg
                  // Clear selection so user can re-scan them
                  updateSelectedOrders((draft) => {
                    ordersNeedingReroute.forEach((o) => draft.delete(o.id));
                  });
                  // Clear scanned orders that were rerouted so they can be re-scanned
                  setScannedOrders((prev) =>
                    prev.filter((item) =>
                      !ordersNeedingReroute.some((o) => o.order_id === item.order.order_id)
                    )
                  );
                  showMessage('Orders rerouted successfully! Please re-scan them to add to batch.');
                }}
              />

              {/* Reroute Confirmation Dialog for single order scan */}
              <RerouteConfirmationDialog
                order={pendingRerouteDecoding?.order || null}
                isOpen={rerouteConfirmDialogOpen}
                onClose={() => {
                  setRerouteConfirmDialogOpen(false);
                  setPendingRerouteDecoding(null);
                }}
                onSuccess={handleRerouteSuccess}
              />
            </>
          )}
        </>
      )}
    </>
  );
}

export default DeliveryBatchForm;
